import React from 'react';
import Tabs from '../Tabs/Tabs';
import ModalButtons from '../ModalButtons/ModalButtons';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import HousekeepingLogWorkspace from './HousekeepingLogWorkspace';
import { parseISO, format } from 'date-fns';
import DateHelper from '../DateHelper/DateHelper';
import HousekeepingLogErrors from './HousekeepingLogErrors';
const _cloneDeep = require('lodash/cloneDeep');


export default class HousekeepingLog extends React.Component{
  constructor(props) {
    super(props);
    var self = this
    this.state = {
      activeTab: 'general',
      errors: [],
      success: null,
      loading: false,
      setTimeOpen: this.props.start_time && this.props.end_time ? true : false,

      revert: this.props.revert || null,
      assigned_to: this.getAssignedTo(),
      currentDate: parseISO(this.props.currentDate) || new Date(),
      customer: this.props.customer,
      date_format: this.props.date_format,
      dateFormat: DateHelper.rubyToDateFNS(this.props.date_format),
      default_housekeeper: this.props.default_housekeeper,
      flagged: this.props.flagged,
      created_at: this.props.created_at ? parseISO(this.props.created_at) : null,
      acknowledged_at: this.props.acknowledged_at ? parseISO(this.props.acknowledged_at) : null,
      finished_at: this.props.finished_at ? parseISO(this.props.finished_at) : null,
      guest_types: this.props.guest_types,
      history_visible: this.props.history_visible,
      housekeeping_log_revision_history_path: this.props.housekeeping_log_revision_history_path,
      housekeeping_log_notes_path: this.props.housekeeping_log_notes_path,
      id: this.props.id,
      file_upload_group: this.props.file_upload_group,
      new_record: this.props.new_record,
      read_only: this.props.read_only,
      reservation: this.props.reservation,
      reservation_segment: this.setReservationSegment(),
      room: this.props.room || null,
      room_group: this.props.room_group,
      room_type: this.props.room_type,
      note_count: this.props.note_count || null,
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null
      },
      scheduled_at: this.getScheduledAt(),//this.props.scheduled_at || this.props.currentDate || new Date(),
      started_at: this.props.started_at ? parseISO(this.props.started_at) : null,
      // startTime: this.props.start_time ? parseISO(this.props.start_time) : null,
      // endTime: this.props.end_time ? parseISO(this.props.end_time) : null,
      startTime: this.props.start_time ? new Date(this.props.start_time) : null,
      endTime: this.props.end_time ? new Date(this.props.end_time) : null,
      status: this.props.status || '',
      time_format: this.props.time_format,
      request_cleaning: this.props.request_cleaning || false,
      housekeeping_type: this.props.housekeeping_type || null,
      all_housekeeping_types: this.props.all_housekeeping_types,
    }
    this.onChange = this.onChange.bind(this)
    this.onChangeRoom = this.onChangeRoom.bind(this)
    this.onChangeRoomGroup = this.onChangeRoomGroup.bind(this)
    this.onChangeRoomType = this.onChangeRoomType.bind(this)
    this.onChangeHousekeepingType = this.onChangeHousekeepingType.bind(this)
    this.onChangeScheduledAt = this.onChangeScheduledAt.bind(this)
    this.onChangeHousekeeper = this.onChangeHousekeeper.bind(this)
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this)
    this.onChangeTab = this.onChangeTab.bind(this)
    this.onChangeFlagged = this.onChangeFlagged.bind(this)
    this.onChangeNote = this.onChangeNote.bind(this);
    this.updateNoteCount = this.updateNoteCount.bind(this);
    this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this);
    this.onChangeTime = this.onChangeTime.bind(this);
    this.onChangeStartTime = this.onChangeStartTime.bind(this);
    this.onChangeEndTime = this.onChangeEndTime.bind(this);
  }

  componentDidMount() {
    var self = this
    $(window).on("housekeepingSaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/housekeeping-logs/${self.props.id}/data`,
      }).done((data) => {
        self.setState({...data});
        self.setState({scheduled_at: new Date(data.scheduled_at)})
      })
    });
  }

  getScheduledAt() {
    if (this.props.scheduled_at) {
      return parseISO(this.props.scheduled_at);
    } else if (this.props.currentDate) {
      return parseISO(this.props.currentDate);
    } else {
      return new Date();
    }
  }

  setReservationSegment() {
    if (this.props.reservation_segment) {
      var resSeg = _cloneDeep(this.props.reservation_segment);
      resSeg.check_in_date = parseISO(resSeg.check_in_date);
      resSeg.check_out_date = parseISO(resSeg.check_out_date);

      return resSeg;
    } else {
      return null
    }

  }

  getAssignedTo() {
    return this.props.assigned_to || this.props.default_housekeeper;
  }

  render() {
    // console.log('sstate', this.state.startTime)
    var self = this;
    if (this.props.read_only == false) {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          self.save();
          return false;
        },
      },
    ]
    } else {
      var buttons = [
        {
          name: I18n.t('ok'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },

      ]
    }

    var revertButtons = [
      {
        name: I18n.t('ok'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
    ]

    return (
      <div className="HousekeepingLog">
        {this.renderErrors()}
        {this.renderSuccess()}
        <Tabs tabs={this.tabs()} displayErrorMessage={(HousekeepingLogErrors.general(this.state.errors).length || HousekeepingLogErrors.room(this.state.errors).length) ? true : false} />
        <div className="panel panel-form">
          <HousekeepingLogWorkspace {...this.state}
              onChange={this.onChange}
              onChangeNote={this.onChangeNote}
              onChangeHousekeeper={this.onChangeHousekeeper}
              onChangeFileUploadGroup={this.onChangeFileUploadGroup}
              onChangeRoom={this.onChangeRoom}
              onChangeRoomGroup={this.onChangeRoomGroup}
              onChangeRoomType={this.onChangeRoomType}
              onChangeHousekeepingType={this.onChangeHousekeepingType}
              onChangeScheduledAt={this.onChangeScheduledAt}
              onChangeFlagged={this.onChangeFlagged}
              onChangeTime={this.onChangeTime}
              onChangeStartTime={this.onChangeStartTime}
              onChangeEndTime={this.onChangeEndTime}
              updateNoteCount={this.updateNoteCount}
              buttons={buttons}
          />
        </div>

        <LoadingSpinner show={this.state.loading} />
        {this.props.revert == true
          ? <ModalButtons loading={this.state.loading} buttons={revertButtons} />
          : <ModalButtons loading={this.state.loading} buttons={buttons} />
        }
      </div>
    );
  }

  renderErrors() {
    if (this.state.errors && this.state.errors.length) {
      let scheduledTime = format(parseISO(this.state.scheduled_at), DateHelper.rubyToDateFNS(this.props.date_format))
      var errors = this.state.errors.map(function (error, idx) {
        return <li key={idx}>{error}</li>
      });
      return (
        <div className="alert alert-danger"><ul>{errors}</ul></div>
      );
    } else {
      return null;
    }
  }

  renderSuccess() {
    if (this.state.success) {
      return <div className="alert-success">{this.state.success}</div>
    } else {
      return null;
    }
  }

  tabs() {
    var tabs =
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
          changeHandler: this.onChangeTab,
          tabErrorCount: HousekeepingLogErrors.general(this.state.errors).length
        },
        {
          tabName: I18n.t('room'),
          targetName: 'room',
          classes: this.state.activeTab === 'room' ? 'active' : null,
          changeHandler: this.onChangeTab,
          tabErrorCount: HousekeepingLogErrors.room(this.state.errors).length,
        },
        {
          tabName: I18n.t('assigned_to'),
          targetName: 'assigned_to',
          classes: this.state.activeTab === 'assigned_to' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t('housekeeping_type'),
          targetName: 'housekeeping_type',
          classes: this.state.activeTab === 'housekeeping_type' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.activeTab === 'notes' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
      ]
      if (!this.props.request_cleaning) {
        tabs.push({
          tabName: I18n.t('status_timeline'),
          targetName: 'status_timeline',
          classes: this.state.activeTab === 'status_timeline' ? 'active' : null,
          changeHandler: this.onChangeTab,
        })
        if (this.props.read_only && this.props.history_visible !== false) {
          tabs.push({
            tabName: I18n.t('history'),
            targetName: 'history',
            classes: this.state.activeTab === 'history' ? 'active' : null,
            changeHandler: this.onChangeTab,
          })
        }
      }
      
      return tabs
  };

  onChange(event) {
    // console.log('onChange', event.target.name, event.target.value);
    this.state[event.target.name] = event.target.value;
    this.forceUpdate();
  }

  onChangeTime(value, name) {
    this.setState({
        [name]: value,
    });
  };

  onChangeStartTime(time) {
    // let log = Object.assign({}, this.state.service_log)
    // log.startTime = time
    this.setState({
      startTime: time,
    })
  }

  onChangeEndTime(time) {
    // let log = Object.assign({}, this.state.service_log)
    // log.endTime = time
    this.setState({
      endTime: time,
    })

  }
  onChangeRoom(room, housekeeper_name, housekeeper_id) {
    if(this.state.assigned_to) {
    this.setState({room: room});
    } else {
      this.setState({
        room: room,
        assigned_to: {
          id: housekeeper_id,
          name: housekeeper_name,
          text: housekeeper_name
        }
      });
    }
    this.forceUpdate();
  }

  onChangeRoomGroup(room_group, housekeeper_name, housekeeper_id) {

    if(this.state.assigned_to) {
      this.setState({
        room_group: room_group
      })
    } else {
      this.setState({
        room_group: room_group,
        assigned_to: {
          id: housekeeper_id,
          name: housekeeper_name,
          text: housekeeper_name
        }
      });
    }
    this.forceUpdate();
  }

  updateNoteCount(count) {
    this.setState({note_count: count})
  }

  onChangeRoomType(room_type) {
    //console.log('change roomtype', room_type);
    this.setState({room_type: room_type});
  }

  onChangeHousekeepingType(event) {
    var housekeeping_type = {...this.state.housekeeping_type}
    housekeeping_type.id = event.target.value

    this.setState({housekeeping_type: housekeeping_type});
  }

  onChangeScheduledAt(scheduled_at) {
    //console.log('change scheduledat', scheduled_at);
    this.setState({scheduled_at: scheduled_at});
  }

  // onChangeHousekeeper(housekeeper) {
  //   if(housekeeper && housekeeper.text){
  //     this.setState({assigned_to: housekeeper});
  //   } else {
  //     this.setState({assigned_to: null})
  //   }
  // }

  onChangeHousekeeper(user) {
    if(user){
      user.element = null
    }
    this.setState({
      assigned_to: user,
    })

  }

  onChangeFileUploadGroup(file_upload_group) {
    this.setState({file_upload_group: file_upload_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      })
    }
  }

  onChangeFlagged(event) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = event.target.checked
    this.setState({note_obj: note_obj, flagged: event.target.checked});
  }

  onChangeTab(activeTab) {
    this.setState({activeTab: activeTab});
  }

  save() {
    var self = this;

    this.setState({loading: true});

    if (self.laddaSubmitButton) {
      self.laddaSubmitButton.start();
    }

    if (this.state.note_obj.note) {
      var note_obj = this.state.note_obj
    }

    $.ajax({
      type: 'POST',
      url: '/admin/housekeeping_logs/save',
      data: {
        assigned_to_id: this.state.assigned_to ? this.state.assigned_to.id : null,
        flagged: this.state.flagged,
        housekeeping_type: this.state.housekeeping_type,
        id: this.state.id,
        file_group_files: this.state.file_upload_group && this.state.file_upload_group.file_uploads ? this.state.file_upload_group.file_uploads.map(file => file.id) : null,
        note: note_obj || null,
        reservation_segment_id: this.state.reservation_segment ? this.state.reservation_segment.id : null,
        room_id: this.state.room ? this.state.room.id : null,
        room_group_id: this.state.room_group ? this.state.room_group.id : null,
        room_type_id: this.state.room_type ? this.state.room_type.id : null,
        scheduled_at: this.state.scheduled_at,
        // scheduled_start_time: this.state.startTime ? format(new Date(this.state.startTime), DateHelper.rubyToDateFNS(this.props.time_format)) : null,
        // scheduled_end_time: this.state.endTime ? format(new Date(this.state.endTime), DateHelper.rubyToDateFNS(this.props.date_format)) : null,
        scheduled_start_time: self.state.startTime,
        scheduled_end_time: self.state.endTime,
        status: this.state.status
      },
    }).done((data) => {
      if (self.laddaSubmitButton) {
        self.laddaSubmitButton.stop();
      }

      if (data.errors) {
        self.setState({errors: data.errors, success: null, loading: false});
      } else if (data.success) {
        // console.log("R", self.props)
        if (this.props.new_record == true) {
          self.setState({errors: null, success: I18n.t('housekeeping_log_created_successfully'), loading: false}, () => {
            if (self.props.onSuccess) {
              self.props.onSuccess();
            }
            window.handleAlertSuccess();
          });
        } else {
          self.setState({errors: null, success: I18n.t('housekeeping_log_saved_successfully'), loading: false}, () => {
            if (self.props.onSuccess) {
              self.props.onSuccess();
            }
            window.handleAlertSuccess();
          });
        }
      }
    });
  }

  onChangeRevertVersion() {
    var self = this
    this.setState({loading: true});
    $.ajax({
      type: 'POST',
      url: `/admin/housekeeping_logs/${self.props.id}/version/${self.props.version.id}/revert`,
    }).done((data) => {
      // console.log(data)
      window.parent.$(window.parent).trigger('housekeepingSaved');
      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('record_reverted_successfully'));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    })
  }

};
